interface Props {
  onClick: () => void;
}
const SvgRemoveFile: React.FC<Props> = ({ onClick }) => {
  return (
    <svg
      onClick={onClick}
      style={{ cursor: "pointer" }}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_14315_60338)">
        <circle cx="9" cy="9" r="4.5" fill="white" />
        <path
          d="M9 1.5C4.85775 1.5 1.5 4.85775 1.5 9C1.5 13.1423 4.85775 16.5 9 16.5C13.1423 16.5 16.5 13.1423 16.5 9C16.5 4.85775 13.1423 1.5 9 1.5ZM11.8354 11.0396C12.0551 11.2594 12.0551 11.6152 11.8354 11.835C11.7255 11.9452 11.5815 12 11.4375 12C11.2935 12 11.1495 11.9453 11.0396 11.8354L9 9.79537L6.96038 11.835C6.8505 11.9452 6.7065 12 6.5625 12C6.4185 12 6.2745 11.9453 6.16462 11.8354C5.94487 11.6156 5.94487 11.2598 6.16462 11.04L8.20463 9L6.165 6.96038C5.94525 6.74063 5.94525 6.38475 6.165 6.165C6.38475 5.94525 6.74063 5.94525 6.96038 6.165L9 8.20463L11.0396 6.165C11.2594 5.94525 11.6152 5.94525 11.835 6.165C12.0547 6.38475 12.0547 6.74063 11.835 6.96038L9.79537 9L11.8354 11.0396Z"
          fill="#EB5757"
        />
      </g>
      <defs>
        <clipPath id="clip0_14315_60338">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgRemoveFile;
